import { POTENTIAL_OWNERS } from './ClientVisitConstants';
import { Property } from '../../types';
import { parseScheduleString } from '../../utils/scheduleParser';

export const DEFAULT_CLIENT_SCHEDULE = "Lu-Vi 08:00-17:00; Sa 08:00-12:00";

export const getMinDateString = () => {
    const minDate = new Date();
    minDate.setHours(minDate.getHours() + 48);
    return minDate.toISOString().split('T')[0];
};

export const getDayOfWeek = (dateString: string): number => {
    if (!dateString) return -1;
    const [year, month, day] = dateString.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.getDay();
};

export const determineOwner = (strategy: string | null | undefined, defaultOwner: string): string => {
    if (!strategy) return defaultOwner;
    const norm = (s: string) => s.toLowerCase().trim();
    const normalizedStrategy = norm(strategy);

    if (normalizedStrategy.includes('habi')) return "Habi";

    for (const owner of POTENTIAL_OWNERS) {
        if (normalizedStrategy.includes(norm(owner))) return owner;
    }
    return defaultOwner;
};

export const getPropertyShareUrl = (property: Property) => {
    const shortCode = property.codigo.startsWith('183150') ? 'c' : 'b';
    return `${window.location.origin}/share/${property.id}?collection=${shortCode}`;
};

export const fetchVisitConfigForProperty = async (property: Property) => {
    const fallbackSchedule = parseScheduleString(DEFAULT_CLIENT_SCHEDULE) || {
        LUNES: { INICIO: 8, FIN: 17 },
        MARTES: { INICIO: 8, FIN: 17 },
        MIERCOLES: { INICIO: 8, FIN: 17 },
        JUEVES: { INICIO: 8, FIN: 17 },
        VIERNES: { INICIO: 8, FIN: 17 },
        SABADO: { INICIO: 8, FIN: 12 }
    };

    try {
        let scheduleData: any = null;
        if (property.owner) {
            try {
                const res = await fetch('/api/config/inmobiliarias');
                const data = await res.json();
                if (data.success && data.inmobiliarias?.[property.owner]?.horario) {
                    scheduleData = parseScheduleString(data.inmobiliarias[property.owner].horario);
                }
            } catch (apiErr) {
                console.warn("API config fetch fallback:", apiErr);
            }
        }

        const customSchedule = parseScheduleString(property.disponibilidad_visitas);
        if (customSchedule) scheduleData = customSchedule;

        return {
            DIAS_ANTICIPACION: 2,
            HORARIO: scheduleData || fallbackSchedule
        };
    } catch (err) {
        console.error("Error fetching visit schedule config:", err);
        return {
            DIAS_ANTICIPACION: 2,
            HORARIO: fallbackSchedule
        };
    }
};